export type VerifiedEntityType = 'radio' | 'locutor' | 'programa';
export type VerificationStatus = 'verificado' | 'pendiente' | 'rechazado' | 'revocado';

export interface VerificationRecord {
  id: number;
  entityType: VerifiedEntityType;
  entityName: string;
  entityId: number;
  entityDetail: string;
  entityImageUrl: string;
  verificationDate: string;
  status: VerificationStatus;
  reason: string;
  reviewer: string;
  notes: string;
  badgeNumber: string;
}

export const verificationRecords: VerificationRecord[] = [
  /* ═══════════ RADIOS ═══════════ */
  {
    id: 1,
    entityType: 'radio',
    entityName: 'Radio Éxito FM',
    entityId: 1,
    entityDetail: '98.5 FM · Buenos Aires, Argentina',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20station%20logo%20design%2C%20modern%20minimalist%20broadcast%20identity%2C%20warm%20gold%20and%20emerald%20tones%2C%20clean%20circular%20emblem%20with%20frequency%20numbers%2C%20abstract%20sound%20wave%20motif%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-exito&orientation=squarish',
    verificationDate: '2024-01-22',
    status: 'verificado',
    reason: 'Cumple con todos los estándares RFW: stream estable 99.7%, programación verificada, identidad de marca consistente.',
    reviewer: 'Super Admin',
    notes: 'Radio fundadora del ecosistema RFW. Primera en recibir la insignia oficial. Auditoría de calidad superada en todas las categorías.',
    badgeNumber: 'RFW-R-00001',
  },
  {
    id: 2,
    entityType: 'radio',
    entityName: 'Estéreo Capital',
    entityId: 2,
    entityDetail: '102.1 FM · Ciudad de México, México',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20station%20logo%20design%2C%20urban%20contemporary%20broadcast%20identity%2C%20warm%20coral%20and%20cream%20tones%2C%20clean%20geometric%20emblem%20with%20frequency%2C%20sound%20bars%20motif%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-estereo-capital&orientation=squarish',
    verificationDate: '2024-03-15',
    status: 'verificado',
    reason: 'Excelente calidad de stream, programación diversa y métricas de audiencia en crecimiento constante.',
    reviewer: 'Super Admin',
    notes: 'Segunda radio verificada. Destaca por su oferta de entretenimiento y música. Locutores estrella como Valentina Ríos y Álex Mendoza.',
    badgeNumber: 'RFW-R-00002',
  },
  {
    id: 3,
    entityType: 'radio',
    entityName: 'Radio Deportiva Total',
    entityId: 3,
    entityDetail: '95.7 FM · Monterrey, México',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20logo%20design%2C%20dynamic%20energetic%20broadcast%20identity%2C%20warm%20orange%20and%20charcoal%20tones%2C%20bold%20emblem%20with%20frequency%20numbers%2C%20stadium-inspired%20geometric%20pattern%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-deportiva&orientation=squarish',
    verificationDate: '2024-04-08',
    status: 'verificado',
    reason: 'Contenido deportivo de alta calidad, métricas sólidas y equipo de locutores certificados.',
    reviewer: 'Super Admin',
    notes: 'Referente en periodismo deportivo radial. Beto Fuentes lidera la programación con audiencias récord.',
    badgeNumber: 'RFW-R-00003',
  },
  {
    id: 4,
    entityType: 'radio',
    entityName: 'Radio Élite Digital',
    entityId: 4,
    entityDetail: '99.1 FM · Bogotá, Colombia',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20radio%20station%20logo%20design%2C%20sleek%20minimalist%20broadcast%20identity%2C%20warm%20violet%20and%20silver%20tones%2C%20clean%20circular%20emblem%2C%20pixel-inspired%20geometric%20motif%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-elite&orientation=squarish',
    verificationDate: '2024-05-20',
    status: 'verificado',
    reason: 'Innovación en formatos digitales, alta interacción comunitaria y estándares técnicos superiores.',
    reviewer: 'Super Admin',
    notes: 'Radio pionera en formatos híbridos radio-podcast. Carolina Vega y Diego Quintero como talentos destacados.',
    badgeNumber: 'RFW-R-00004',
  },
  {
    id: 5,
    entityType: 'radio',
    entityName: 'Radio Industria',
    entityId: 5,
    entityDetail: '93.5 FM · Santiago, Chile',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20radio%20station%20logo%20design%2C%20serious%20trustworthy%20broadcast%20identity%2C%20navy%20and%20cream%20tones%2C%20clean%20emblem%20with%20frequency%2C%20newspaper-inspired%20typography%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-industria&orientation=squarish',
    verificationDate: '2024-06-10',
    status: 'verificado',
    reason: 'Rigor periodístico comprobado, equipo de investigación galardonado y compromiso con la verdad.',
    reviewer: 'Super Admin',
    notes: 'Gabriela Sotomayor lidera el noticiero más respetado. Premio Nacional de Periodismo 2024.',
    badgeNumber: 'RFW-R-00005',
  },
  {
    id: 6,
    entityType: 'radio',
    entityName: 'Radio Cultura Digital',
    entityId: 6,
    entityDetail: '91.3 FM · Lima, Perú',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Cultural%20radio%20station%20logo%20design%2C%20elegant%20refined%20broadcast%20identity%2C%20warm%20terracotta%20and%20gold%20tones%2C%20classic%20emblem%20with%20frequency%2C%20artistic%20brush%20motif%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-cultura&orientation=squarish',
    verificationDate: '2024-07-05',
    status: 'verificado',
    reason: 'Contenido cultural de excelencia, divulgación artística de alto nivel y programación educativa verificada.',
    reviewer: 'Super Admin',
    notes: 'Lucía Fernández eleva la música clásica en radio. Espacio cultural más premiado de Perú.',
    badgeNumber: 'RFW-R-00006',
  },
  {
    id: 7,
    entityType: 'radio',
    entityName: 'Radio Peninsular',
    entityId: 7,
    entityDetail: '101.9 FM · Caracas, Venezuela',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20radio%20station%20logo%20design%2C%20vintage%20elegant%20broadcast%20identity%2C%20warm%20sepia%20and%20copper%20tones%2C%20retro%20circular%20emblem%20with%20frequency%2C%20vinyl-inspired%20geometric%20motif%2C%20premium%20brand%20identity%20design&width=400&height=400&seq=verification-radio-peninsular&orientation=squarish',
    verificationDate: '2024-08-18',
    status: 'verificado',
    reason: 'Trayectoria comprobada de más de 35 años, legado cultural y audiencia multigeneracional fiel.',
    reviewer: 'Super Admin',
    notes: 'Hugo Cárdenas, leyenda viva de la radio. Programa líder de audiencia por 20 años consecutivos.',
    badgeNumber: 'RFW-R-00007',
  },
  {
    id: 8,
    entityType: 'radio',
    entityName: 'Radio Costa Azul',
    entityId: 8,
    entityDetail: '88.7 FM · San José, Costa Rica',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Coastal%20lifestyle%20radio%20station%20logo%20design%2C%20fresh%20vibrant%20broadcast%20identity%2C%20teal%20and%20sand%20tones%2C%20clean%20circular%20emblem%20with%20frequency%2C%20wave-inspired%20geometric%20pattern%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-costa-azul&orientation=squarish',
    verificationDate: '2025-01-10',
    status: 'pendiente',
    reason: 'Solicitud de verificación en proceso. Pendiente de completar documentación técnica y auditoría de stream.',
    reviewer: '—',
    notes: 'Radio en crecimiento con Mariana Duarte y Sofía Rangel. Falta certificar uptime del stream y completar el perfil de marca.',
    badgeNumber: 'RFW-R-00008',
  },
  {
    id: 9,
    entityType: 'radio',
    entityName: 'Radio Horizonte FM',
    entityId: 9,
    entityDetail: '104.3 FM · Quito, Ecuador',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20design%2C%20horizon-inspired%20broadcast%20identity%2C%20warm%20gradient%20amber%20and%20deep%20blue%20tones%2C%20clean%20emblem%20with%20frequency%2C%20sunrise%20geometric%20motif%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-horizonte&orientation=squarish',
    verificationDate: '2025-02-20',
    status: 'rechazado',
    reason: 'No cumple con el estándar mínimo de calidad de stream (uptime 82%, requiere 95%+). Contenido sin verificar.',
    reviewer: 'Super Admin',
    notes: 'Rechazada por incumplimiento técnico. Se recomendó mejorar infraestructura de streaming y reaplicar en 90 días. Seguimiento programado para mayo 2025.',
    badgeNumber: 'RFW-R-00009',
  },
  {
    id: 10,
    entityType: 'radio',
    entityName: 'Antena Joven FM',
    entityId: 10,
    entityDetail: '107.9 FM · Córdoba, Argentina',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Youth%20radio%20station%20logo%20design%2C%20energetic%20bold%20broadcast%20identity%2C%20vibrant%20coral%20and%20charcoal%20tones%2C%20modern%20emblem%20with%20frequency%2C%20dynamic%20geometric%20pattern%2C%20premium%20brand%20identity%20design%2C%20dark%20background&width=400&height=400&seq=verification-radio-antena-joven&orientation=squarish',
    verificationDate: '2025-03-05',
    status: 'revocado',
    reason: 'Insignia revocada por incumplimiento reiterado del código de conducta RFW y uso no autorizado de contenido.',
    reviewer: 'Super Admin',
    notes: 'Verificación retirada tras 3 advertencias. La radio puede volver a solicitar verificación después de 6 meses si demuestra corrección de las faltas.',
    badgeNumber: 'RFW-R-00010',
  },

  /* ═══════════ LOCUTORES ═══════════ */
  {
    id: 11,
    entityType: 'locutor',
    entityName: 'Martín Castellanos',
    entityId: 1,
    entityDetail: 'Periodista · Buenos Aires, Argentina · 284K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20host%20in%20his%20thirties%2C%20warm%20confident%20expression%2C%20studio%20microphone%20in%20background%20softly%20blurred%2C%20wearing%20casual%20elegant%20dark%20shirt%2C%20warm%20studio%20lighting%2C%20editorial%20portrait%20photography%2C%20clean%20professional%20background&width=400&height=400&seq=verification-broadcaster-martin&orientation=squarish',
    verificationDate: '2024-02-05',
    status: 'verificado',
    reason: 'Trayectoria comprobada de 15+ años, comunidad consolidada y estándares profesionales de locución impecables.',
    reviewer: 'Super Admin',
    notes: 'Primer locutor verificado del ecosistema. Referente del periodismo radial argentino. 500+ entrevistas a personalidades.',
    badgeNumber: 'RFW-L-00001',
  },
  {
    id: 12,
    entityType: 'locutor',
    entityName: 'Valentina Ríos',
    entityId: 2,
    entityDetail: 'Comunicadora · Ciudad de México, México · 512K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20late%20twenties%2C%20friendly%20smile%2C%20modern%20broadcast%20studio%20with%20warm%20lighting%2C%20wearing%20stylish%20cream%20blazer%2C%20headphones%20around%20neck%2C%20editorial%20portrait%20photography%2C%20clean%20warm%20background&width=400&height=400&seq=verification-broadcaster-valentina&orientation=squarish',
    verificationDate: '2024-04-12',
    status: 'verificado',
    reason: 'Mayor comunidad digital del ecosistema, innovación en formatos juveniles y nominación a Mejor Locutora Revelación.',
    reviewer: 'Super Admin',
    notes: 'Fundadora del movimiento #RadioJoven. Su comunidad supera el medio millón de seguidores. Embajadora de la marca RFW.',
    badgeNumber: 'RFW-L-00002',
  },
  {
    id: 13,
    entityType: 'locutor',
    entityName: 'Roberto "Beto" Fuentes',
    entityId: 3,
    entityDetail: 'Periodista Deportivo · Monterrey, México · 385K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20sports%20commentator%20in%20his%20forties%2C%20energetic%20expression%2C%20wearing%20polo%20shirt%2C%20sports%20broadcast%20studio%20with%20screens%20showing%20match%20highlights%2C%20dynamic%20energy%2C%20editorial%20portrait%2C%20warm%20dramatic%20lighting&width=400&height=400&seq=verification-broadcaster-beto&orientation=squarish',
    verificationDate: '2024-05-08',
    status: 'verificado',
    reason: '22 años de trayectoria, cobertura de eventos internacionales y análisis táctico de referencia en Latinoamérica.',
    reviewer: 'Super Admin',
    notes: '4 Copas del Mundo y 6 Juegos Olímpicos cubiertos. Autor del libro "El Fútbol que Vivimos".',
    badgeNumber: 'RFW-L-00003',
  },
  {
    id: 14,
    entityType: 'locutor',
    entityName: 'Carolina Vega',
    entityId: 4,
    entityDetail: 'Psicóloga y Locutora · Bogotá, Colombia · 198K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20elegant%20and%20approachable%2C%20warm%20studio%20with%20acoustic%20panels%2C%20wearing%20elegant%20burgundy%20top%2C%20soft%20professional%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=verification-broadcaster-carolina&orientation=squarish',
    verificationDate: '2024-06-15',
    status: 'verificado',
    reason: 'Divulgación en salud mental de alto impacto, comunidad fiel y reconocimiento de la Asociación de Psicología.',
    reviewer: 'Super Admin',
    notes: 'Divulgadora del Año. Su programa "Conversaciones Reales" es recomendado por asociaciones profesionales de psicología.',
    badgeNumber: 'RFW-L-00004',
  },
  {
    id: 15,
    entityType: 'locutor',
    entityName: 'Alejandro "Álex" Mendoza',
    entityId: 5,
    entityDetail: 'DJ y Productor · Medellín, Colombia · 246K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20DJ%20and%20music%20host%20in%20his%20thirties%2C%20cool%20and%20stylish%20with%20headphones%2C%20modern%20music%20studio%20with%20vinyl%20collection%20background%2C%20wearing%20black%20t-shirt%2C%20warm%20moody%20lighting%2C%20editorial%20portrait&width=400&height=400&seq=verification-broadcaster-alex&orientation=squarish',
    verificationDate: '2024-07-22',
    status: 'verificado',
    reason: 'Referente de música electrónica en Latinoamérica, fundador de sello independiente y presencia en festivales internacionales.',
    reviewer: 'Super Admin',
    notes: 'DJ en Lollapalooza y Estéreo Picnic. Fundador de Onda Latina Records. Verificación destacada por aporte cultural.',
    badgeNumber: 'RFW-L-00005',
  },
  {
    id: 16,
    entityType: 'locutor',
    entityName: 'Gabriela Sotomayor',
    entityId: 6,
    entityDetail: 'Periodista de Investigación · Santiago, Chile · 178K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20news%20anchor%20and%20radio%20host%20in%20her%20forties%2C%20authoritative%20yet%20warm%20presence%2C%20newsroom%20background%20with%20screens%2C%20wearing%20navy%20professional%20attire%2C%20confident%20expression%2C%20editorial%20portrait&width=400&height=400&seq=verification-broadcaster-gabriela&orientation=squarish',
    verificationDate: '2024-08-10',
    status: 'verificado',
    reason: 'Premio Nacional de Periodismo, investigaciones de alto impacto y rigor ético intachable.',
    reviewer: 'Super Admin',
    notes: 'Ha destapado casos de corrupción que cambiaron políticas públicas. Profesora universitaria de Ética Periodística.',
    badgeNumber: 'RFW-L-00006',
  },
  {
    id: 17,
    entityType: 'locutor',
    entityName: 'Diego Armando Quintero',
    entityId: 7,
    entityDetail: 'Creador de Contenido · Buenos Aires, Argentina · 420K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20radio%20host%20in%20his%20twenties%2C%20enthusiastic%20and%20charismatic%2C%20modern%20podcast%20studio%20setup%2C%20wearing%20colorful%20hoodie%2C%20genuine%20smile%2C%20creative%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=verification-broadcaster-diego&orientation=squarish',
    verificationDate: '2025-02-01',
    status: 'verificado',
    reason: 'Comunidad masiva en gaming y tecnología, 2M+ descargas de podcast y embajador de marcas tech.',
    reviewer: 'Super Admin',
    notes: 'Verificación destacada. A sus 24 años, es el locutor verificado más joven del ecosistema RFW.',
    badgeNumber: 'RFW-L-00007',
  },
  {
    id: 18,
    entityType: 'locutor',
    entityName: 'Sofía Rangel',
    entityId: 12,
    entityDetail: 'Coach de Bienestar · Guadalajara, México · 42K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20calm%20and%20meditative%20presence%2C%20wellness%20studio%20with%20plants%20and%20natural%20elements%2C%20wearing%20linen%20neutral%20clothing%2C%20soft%20natural%20light%2C%20editorial%20portrait&width=400&height=400&seq=verification-broadcaster-sofia&orientation=squarish',
    verificationDate: '2025-04-10',
    status: 'pendiente',
    reason: 'Solicitud en evaluación. Se requiere verificar métricas mínimas de audiencia y consistencia de contenido.',
    reviewer: '—',
    notes: 'Cumple con criterios cualitativos pero está por debajo del umbral mínimo de seguidores (50K). En período de gracia de 60 días.',
    badgeNumber: 'RFW-L-00008',
  },
  {
    id: 19,
    entityType: 'locutor',
    entityName: 'Lucía Fernández',
    entityId: 8,
    entityDetail: 'Musicóloga · Lima, Perú · 95K seguidores',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20thirties%2C%20sophisticated%20and%20warm%2C%20classical%20music%20studio%20background%2C%20wearing%20elegant%20silk%20blouse%2C%20soft%20artistic%20lighting%2C%20editorial%20portrait%20photography&width=400&height=400&seq=verification-broadcaster-lucia&orientation=squarish',
    verificationDate: '2024-10-05',
    status: 'rechazado',
    reason: 'No alcanza el umbral mínimo de interacciones comunitarias requerido para la verificación (mínimo 10K/mes).',
    reviewer: 'Super Admin',
    notes: 'Calidad de contenido excepcional pero comunidad pequeña. Se sugiere estrategia de crecimiento y reaplicar en 6 meses.',
    badgeNumber: 'RFW-L-00009',
  },

  /* ═══════════ PROGRAMAS ═══════════ */
  {
    id: 20,
    entityType: 'programa',
    entityName: 'Mañanas Argentinas',
    entityId: 1,
    entityDetail: 'Noticias · Radio Éxito FM 98.5 · Lun-Vie 06:00-10:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20morning%20show%20studio%20scene%20with%20warm%20sunrise%20lighting%20through%20large%20windows%2C%20multiple%20microphones%20on%20a%20wooden%20desk%2C%20coffee%20cups%2C%20newspapers%2C%20energetic%20atmosphere%2C%20editorial%20broadcast%20photography%2C%20soft%20golden%20hour%20tones&width=400&height=400&seq=verification-program-mananas&orientation=squarish',
    verificationDate: '2024-02-20',
    status: 'verificado',
    reason: 'Programa insignia de RFW, 15+ años al aire, equipo de 8 periodistas y cobertura nacional verificada.',
    reviewer: 'Super Admin',
    notes: 'Primer programa verificado. Martín Castellanos como conductor principal. Referente del periodismo matutino.',
    badgeNumber: 'RFW-P-00001',
  },
  {
    id: 21,
    entityType: 'programa',
    entityName: 'Tardes con Vale',
    entityId: 2,
    entityDetail: 'Entretenimiento · Estéreo Capital 102.1 · Lun-Vie 16:00-19:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Energetic%20afternoon%20radio%20show%20studio%2C%20colorful%20neon%20signs%20on%20walls%2C%20modern%20pop%20culture%20aesthetic%2C%20pink%20and%20warm%20orange%20ambient%20lighting%2C%20DJ%20mixer%20visible%2C%20vibrant%20youthful%20broadcast%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=verification-program-tardes&orientation=squarish',
    verificationDate: '2024-05-01',
    status: 'verificado',
    reason: 'Programa con mayor comunidad del ecosistema (512K seguidores), formato innovador radio+streaming+redes.',
    reviewer: 'Super Admin',
    notes: 'Valentina Ríos revolucionó la radio juvenil. Chat en vivo con comunidad vibrante que decide contenido.',
    badgeNumber: 'RFW-P-00002',
  },
  {
    id: 22,
    entityType: 'programa',
    entityName: 'Deporte Total',
    entityId: 3,
    entityDetail: 'Deportes · Radio Deportiva Total 95.7 · Lun-Vie 18:00-21:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20studio%20with%20multiple%20large%20screens%20showing%20live%20match%20highlights%2C%20sports%20memorabilia%20on%20shelves%2C%20professional%20broadcast%20desk%2C%20dramatic%20stadium-like%20lighting%2C%20editorial%20sports%20photography&width=400&height=400&seq=verification-program-deporte&orientation=squarish',
    verificationDate: '2024-06-01',
    status: 'verificado',
    reason: 'Programa deportivo más escuchado, 142K comentarios de comunidad y equipo de 5 especialistas.',
    reviewer: 'Super Admin',
    notes: 'Beto Fuentes lidera con análisis táctico de primer nivel. Mayor interacción en vivo de toda la plataforma.',
    badgeNumber: 'RFW-P-00003',
  },
  {
    id: 23,
    entityType: 'programa',
    entityName: 'Conversaciones Reales',
    entityId: 4,
    entityDetail: 'Salud · Radio Élite Digital 99.1 · Lun-Vie 21:00-23:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Intimate%20warm%20radio%20studio%20atmosphere%20with%20soft%20amber%20lighting%2C%20comfortable%20armchairs%20facing%20each%20other%2C%20acoustic%20panels%20on%20walls%2C%20plants%2C%20gentle%20candle-like%20warm%20glow%2C%20emotional%20depth%2C%20editorial%20photography&width=400&height=400&seq=verification-program-conversaciones&orientation=squarish',
    verificationDate: '2024-07-15',
    status: 'verificado',
    reason: 'Programa validado por la Asociación de Psicología, contenido de salud mental con respaldo profesional.',
    reviewer: 'Super Admin',
    notes: 'Carolina Vega creó un espacio seguro y reconocido. Único programa radial avalado por asociaciones de psicología.',
    badgeNumber: 'RFW-P-00004',
  },
  {
    id: 24,
    entityType: 'programa',
    entityName: 'Onda Nocturna',
    entityId: 5,
    entityDetail: 'Música · Estéreo Capital 102.1 · Lun-Jue 22:00-01:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20radio%20studio%20with%20purple%20and%20blue%20neon%20ambient%20lighting%2C%20vinyl%20turntables%20visible%2C%20DJ%20mixer%20with%20glowing%20knobs%2C%20atmospheric%20haze%2C%20sophisticated%20underground%20music%20club%20aesthetic%2C%20editorial%20photography&width=400&height=400&seq=verification-program-onda&orientation=squarish',
    verificationDate: '2024-08-20',
    status: 'verificado',
    reason: 'Programa nocturno más escuchado de Latinoamérica, curaduría musical de excelencia y comunidad fiel.',
    reviewer: 'Super Admin',
    notes: 'Álex Mendoza, DJ y productor, crea experiencias sonoras únicas. Guest mixes y estrenos exclusivos cada semana.',
    badgeNumber: 'RFW-P-00005',
  },
  {
    id: 25,
    entityType: 'programa',
    entityName: 'Noticiero Primera Edición',
    entityId: 6,
    entityDetail: 'Noticias · Radio Industria 93.5 · Lun-Vie 07:00-09:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20broadcast%20studio%20with%20large%20digital%20screens%20showing%20world%20maps%20and%20headlines%2C%20clean%20modern%20newsroom%20aesthetic%2C%20serious%20yet%20approachable%20atmosphere%2C%20morning%20light%20through%20frosted%20glass%2C%20editorial%20photography&width=400&height=400&seq=verification-program-noticiero&orientation=squarish',
    verificationDate: '2024-09-10',
    status: 'verificado',
    reason: 'Noticiero más riguroso del ecosistema, corresponsales en 8 ciudades e investigaciones de alto impacto.',
    reviewer: 'Super Admin',
    notes: 'Gabriela Sotomayor lidera con estándares de periodismo de investigación. Premio Nacional de Periodismo.',
    badgeNumber: 'RFW-P-00006',
  },
  {
    id: 26,
    entityType: 'programa',
    entityName: 'Modo Creativo',
    entityId: 7,
    entityDetail: 'Tecnología · Radio Élite Digital 99.1 · Lun-Vie 19:00-21:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20and%20tech%20podcast%20studio%20with%20RGB%20LED%20strips%2C%20multiple%20monitors%20displaying%20game%20streams%2C%20neon%20gaming%20peripherals%2C%20fun%20colorful%20aesthetic%2C%20youthful%20energetic%20broadcast%20vibe%2C%20cyberpunk-inspired%20lighting%2C%20editorial%20photography&width=400&height=400&seq=verification-program-modo&orientation=squarish',
    verificationDate: '2025-01-25',
    status: 'verificado',
    reason: '2M+ descargas de podcast, comunidad más interactiva del ecosistema (125K comentarios) y contenido innovador.',
    reviewer: 'Super Admin',
    notes: 'Diego Quintero construyó la comunidad tech más grande de la radio latinoamericana. Verificación destacada.',
    badgeNumber: 'RFW-P-00007',
  },
  {
    id: 27,
    entityType: 'programa',
    entityName: 'El Desparche',
    entityId: 11,
    entityDetail: 'Comedia · Estéreo Capital 102.1 · Lun-Vie 06:00-09:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20comedy%20radio%20studio%20with%20colorful%20quirky%20decorations%2C%20fun%20neon%20signs%2C%20oversized%20coffee%20mugs%2C%20playful%20chaotic%20organized%20atmosphere%2C%20bright%20warm%20lighting%2C%20humorous%20editorial%20photography%2C%20energetic%20morning%20show%20aesthetic&width=400&height=400&seq=verification-program-desparche&orientation=squarish',
    verificationDate: '2025-02-15',
    status: 'verificado',
    reason: 'Ganador del Martín Fierro digital, frase viral continental y 165K comentarios de comunidad.',
    reviewer: 'Super Admin',
    notes: 'Ricky Navarro convirtió las mañanas en una fiesta. El programa más comentado de toda la plataforma.',
    badgeNumber: 'RFW-P-00008',
  },
  {
    id: 28,
    entityType: 'programa',
    entityName: 'Respira',
    entityId: 12,
    entityDetail: 'Salud · Radio Costa Azul 88.7 · Lun-Vie 06:00-07:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20wellness%20radio%20studio%20filled%20with%20plants%20and%20natural%20elements%2C%20soft%20morning%20light%20filtering%20through%20bamboo%20blinds%2C%20meditation%20cushions%20and%20candles%2C%20serene%20calm%20atmosphere%2C%20minimalist%20zen%20aesthetic%2C%20editorial%20photography%2C%20tranquil%20mood&width=400&height=400&seq=verification-program-respira&orientation=squarish',
    verificationDate: '2025-03-20',
    status: 'pendiente',
    reason: 'Contenido de alta calidad cualitativa pero métricas de audiencia por debajo del umbral mínimo (50K seguidores).',
    reviewer: '—',
    notes: 'Programa con excelente recepción cualitativa. Sofía Rangel certificada en yoga y meditación. En período de gracia.',
    badgeNumber: 'RFW-P-00009',
  },
  {
    id: 29,
    entityType: 'programa',
    entityName: 'Clásicos del Mundo',
    entityId: 8,
    entityDetail: 'Cultura · Radio Cultura Digital 91.3 · Lun-Vie 10:00-12:00',
    entityImageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20radio%20studio%20with%20grand%20piano%20in%20soft%20focus%20background%2C%20sheet%20music%20scattered%20on%20a%20wooden%20desk%2C%20warm%20golden%20afternoon%20light%20streaming%20through%20tall%20windows%2C%20sophisticated%20cultural%20atmosphere%2C%20editorial%20photography&width=400&height=400&seq=verification-program-clasicos&orientation=squarish',
    verificationDate: '2024-11-05',
    status: 'revocado',
    reason: 'Insignia revocada por inactividad del programa durante más de 30 días sin notificación previa a RFW.',
    reviewer: 'Super Admin',
    notes: 'El programa estuvo fuera del aire por reestructuración de la radio. Puede volver a solicitar verificación al reanudar emisiones regulares.',
    badgeNumber: 'RFW-P-00010',
  },
];

export const verificationSummary = {
  totalVerified: 18,
  totalPending: 3,
  totalRejected: 2,
  totalRevoked: 2,
  totalRecords: 25,
  verifiedRadios: 7,
  verifiedBroadcasters: 6,
  verifiedPrograms: 8,
  pendingRadios: 1,
  pendingBroadcasters: 1,
  pendingPrograms: 1,
  lastVerificationDate: '2025-04-10',
  badgePrefixes: {
    radio: 'RFW-R',
    locutor: 'RFW-L',
    programa: 'RFW-P',
  },
};